const state = {}

const mutations = {}

const actions = {
    async requestForDelete(_, {
        id,
        type,
    }) {
        try {
            await this.$api.specialists.requestForDelete({
                type,
                id,
            })
        } catch (err) {
            console.log(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
